/**
 * @generated SignedSource<<80a72e3b43a39a3564349e3ad38eb4d7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UserNodeIdTypeEnum = "DATABASE_ID" | "EMAIL" | "ID" | "SLUG" | "URI" | "USERNAME";
export type User_Single_Query$variables = {
  id: string;
  idType?: UserNodeIdTypeEnum | null | undefined;
};
export type User_Single_Query$data = {
  readonly user: {
    readonly avatar: {
      readonly url: string | null | undefined;
    } | null | undefined;
    readonly capabilities: ReadonlyArray<string | null | undefined> | null | undefined;
    readonly description: string | null | undefined;
    readonly email: string | null | undefined;
    readonly firstName: string | null | undefined;
    readonly id: string;
    readonly lastName: string | null | undefined;
    readonly meta: {
      readonly jobRole: string | null | undefined;
      readonly profileArticleLinks: ReadonlyArray<{
        readonly iconName: string | null | undefined;
        readonly name: string | null | undefined;
        readonly url: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly profileImage: {
        readonly description: string | null | undefined;
        readonly id: string;
        readonly mediaDetails: {
          readonly sizes: ReadonlyArray<{
            readonly name: string | null | undefined;
            readonly sourceUrl: string | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly mediaItemUrl: string | null | undefined;
      } | null | undefined;
      readonly profileSocialLinks: ReadonlyArray<{
        readonly name: string | null | undefined;
        readonly url: string | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly name: string | null | undefined;
    readonly nicename: string | null | undefined;
    readonly nickname: string | null | undefined;
    readonly role: string | null | undefined;
    readonly slug: string | null | undefined;
    readonly username: string | null | undefined;
  } | null | undefined;
};
export type User_Single_Query = {
  response: User_Single_Query$data;
  variables: User_Single_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": "ID",
    "kind": "LocalArgument",
    "name": "idType"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "idType",
        "variableName": "idType"
      }
    ],
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "user",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slug",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "role",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "username",
        "storageKey": null
      },
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "nicename",
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "size",
            "value": 10
          }
        ],
        "concreteType": "Avatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": "avatar(size:10)"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User_Meta",
        "kind": "LinkedField",
        "name": "meta",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "jobRole",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MediaItem",
            "kind": "LinkedField",
            "name": "profileImage",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "mediaItemUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MediaDetails",
                "kind": "LinkedField",
                "name": "mediaDetails",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MediaSize",
                    "kind": "LinkedField",
                    "name": "sizes",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sourceUrl",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User_Meta_profileSocialLinks",
            "kind": "LinkedField",
            "name": "profileSocialLinks",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User_Meta_profileArticleLinks",
            "kind": "LinkedField",
            "name": "profileArticleLinks",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "iconName",
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "nickname",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastName",
        "storageKey": null
      },
      (v4/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "capabilities",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "User_Single_Query",
    "selections": (v5/*: any*/),
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "User_Single_Query",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "f2987456e3775e7e089d8e9424b14196",
    "id": null,
    "metadata": {},
    "name": "User_Single_Query",
    "operationKind": "query",
    "text": "query User_Single_Query(\n  $id: ID!\n  $idType: UserNodeIdTypeEnum = ID\n) {\n  user(id: $id, idType: $idType) {\n    id\n    slug\n    role\n    username\n    name\n    nicename\n    avatar(size: 10) {\n      url\n    }\n    meta {\n      jobRole\n      profileImage {\n        id\n        mediaItemUrl\n        mediaDetails {\n          sizes {\n            sourceUrl\n            name\n          }\n        }\n        description\n      }\n      profileSocialLinks {\n        name\n        url\n      }\n      profileArticleLinks {\n        name\n        iconName\n        url\n      }\n    }\n    nickname\n    firstName\n    lastName\n    description\n    email\n    capabilities\n  }\n}\n"
  }
};
})();

(node as any).hash = "0ac5ae66e0177abdcbd0b5d800a99306";

export default node;
